import { NAV_SEQUENCE_TIMEOUT } from "@/lib/shortcut-sequence"

export const CREATE_SEQUENCE_KEYS = { issue: "I", project: "P" } as const

/** The key a sequence starts with, when the picker opens on a single letter like C. */
export function sequencePrefix(shortcut: string) {
	return /^[a-z]$/i.test(shortcut) ? shortcut.toUpperCase() : null
}

// C then I / C then P: the key after the shortcut that opened the picker creates
// instead of searching, inside the same window the g-sequences use.
export function createFromSequence(
	event: Pick<
		KeyboardEvent,
		"key" | "metaKey" | "ctrlKey" | "altKey" | "shiftKey"
	>,
	{
		openedByShortcutAt,
		now,
		query,
		showProjects,
	}: {
		openedByShortcutAt: number
		now: number
		query: string
		showProjects: boolean
	},
): "issue" | "project" | null {
	if (query || now - openedByShortcutAt > NAV_SEQUENCE_TIMEOUT) return null
	if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) {
		return null
	}
	const key = event.key.toUpperCase()
	if (key === CREATE_SEQUENCE_KEYS.issue) return "issue"
	if (key === CREATE_SEQUENCE_KEYS.project && showProjects) return "project"
	return null
}
